import PropTypes from 'prop-types';

var propTypes = {
    errorBody: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    'data-testid': PropTypes.string,
};
var defaultProps = {
    errorBody: 'Error loading data.',
    'data-testid': 'table-error-state-illustration',
};

export { defaultProps, propTypes };
